// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import cstmTable from '../../../../share/components/vue/PaginationTable';
import error from '../../../../common/nodejs/errors';
import config from '../../../../share/config';
import session from '../../../../share/session';

/** 各フェーズ定義 */
const PHASE = {
  START: 'start',
  INPUT_TARGET: 'inputTarget',
  IN_PROGRESS: 'inProgress',
  ERROR_STOP_PROCESS: 'stopProcessError',
  ERROR_COMMUNICATION: 'communicationError',
  ERROR_START_PROCESS: 'startProcessError',
  ERROR_COMMON: 'commonError',
  FAILURE_VISUAL_CONFIRMATION: 'visualConfirmationFailure'
};

/** カメラ種類の定義
 * フロントカメラ: '1'
 * 左サイドカメラ: '2'
 * 右サイドカメラ: '3'
 * リヤカメラ: '4'
 */
const CAMERA_TYPE = {
  FRONT: 1,
  LEFT: 2,
  RIGHT: 3,
  REAR: 4,
};

/** 読出しデータ判別 */
const DATA_RECORD = {
  DATA_PARAM_00: 0,
  DATA_PARAM_01: 1,
  DATA_PARAM_11: 17,
  DATA_PARAM_13: 19,
  DATA_PARAM_51: 81,
  DATA_PARAM_61: 97,
  DATA_PARAM_62: 98,
  DATA_PARAM_64: 100,
  DATA_PARAM_65: 101
};

/** プロセス判別
 *  ※表示するカスタムテーブルの内容が変わるため定義
 */
const CURRENT_PROCESS = {
  INPUT_TARGET: 0,
  ERROR_START_PROCESS_START: 1,
  ERROR_START_PROCESS_EXECUTE: 2,
};

export default {
  name: 'requirement070',
  data() {
    return {
      phase: PHASE.START,
      isLoading: false,
      selectedcameraType: null,
      isDisableButton: true,
      currentProcess: CURRENT_PROCESS.INPUT_TARGET,
      isExecute: false,
      replaceMessage: null,
      bodyItems: [],
      tableItems: [],
      startProcessErrorItems: [],
      startProcessErrorBodyItems: [],
      resultData: {
        front: null,
        left: null,
        right: null,
        rear: null
      },
      columns: {
        front: this.$t(`individual.row_target_front`),
        left: this.$t(`individual.row_target_left`),
        right: this.$t(`individual.row_target_right`),
        rear: this.$t(`individual.row_target_rear`)
      },
      selectData: null,
      selectedItem: {
        itemID: null,
        itemName: null
      },
      modal_requirement_070: false
    };
  },

  props: {
    i18nWsKey: { type: String, default: '', required: true },
    workSupportId: { type: Number, default: '', required: true }
  },
  components: {
    'cstm-table': cstmTable
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),

    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.ERROR_STOP_PROCESS:
        case PHASE.ERROR_COMMUNICATION:
        case PHASE.ERROR_START_PROCESS:
        case PHASE.FAILURE_VISUAL_CONFIRMATION:
        case PHASE.ERROR_COMMON:
          return 'danger';
        case PHASE.START:
        case PHASE.INPUT_TARGET:
        case PHASE.IN_PROGRESS:
        default:
          return 'secondary';
      }
    },

    /**
     * テーブルの内容を設定
     * @returns 各画面の設定内容
     */
    systemTableColumns() {

      if (this.currentProcess === CURRENT_PROCESS.INPUT_TARGET) {
        // 目視確認対象選択画面
        this.tableItems = [
          {
            name: 'itemName',
            label: `individual.label_table_item`
          }
        ];
        return this.tableItems;

      } else {
        // 開始処理エラー画面
        this.startProcessErrorItems = [
          {
            name: 'itemName',
            label: `individual.label_table_item`
          },
          {
            name: 'itemValue',
            label: `individual.label_table_header_error_description`
          }
        ];
        return this.startProcessErrorItems;

      }
    },
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),
    /** 選択された行番号を保持 */
    selectItem(data) {
      this.isDisableButton = false;
      this.selectData = data.itemID;
      this.selectedItem = {
        itemID: data.itemID,
        itemName: data.itemName
      };

      // カメラタイプを設定しておく
      this.selectedcameraType = this.selectedItem.itemID;
      this.setHighLight();
    },

    /**
     * 選択している機能のハイライト設定
     */
    setHighLight() {
      this.bodyItems.forEach(item => {
        if (item.itemID === this.selectedItem.itemID) {
          item.fieldSpec = {};
          item.fieldSpec.itemName = config.LIST_ITEM_HIGHLIGHT;
        } else {
          if (item.fieldSpec) {
            delete item.fieldSpec;
          }
        }
      });
    },

    /** 初期化処理 */
    init() {
      this.modal_requirement_070 = true;
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit('close-wizard');
      this.modal_requirement_070 = false;
    },

    /** その他エラー発生時の表示 */
    showUnexpectedError() {
      this.phase = PHASE.ERROR_COMMON;
    },

    /**
     * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result バリデーション結果
     */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    // 各API実行-------------------------------------------

    /** 画面起動時の起動処理 */
    async start() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: 'start'
        };

        // 初期処理（要求）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              this.currentProcess = CURRENT_PROCESS.INPUT_TARGET;
              // 成功
              this.inputTarget();
              break;
            case config.STATUS_WSP_FAILED:
              // 失敗
              // 各エラー表示
              switch (response.data.async_code) {
                case error.WSP_GENERAL_ERROR:
                  // 共通エラー
                  this.phase = PHASE.ERROR_COMMON;
                  break;
                case error.WSP_070_START_PROCESS_ERROR:
                  // 開始処理エラー
                  // 取得データを割り当て
                  this.currentProcess = CURRENT_PROCESS.ERROR_START_PROCESS_START;

                  this.resultData = {
                    front: this.showContent(response.data.user_data.user_data.front),
                    left: this.showContent(response.data.user_data.user_data.left),
                    right: this.showContent(response.data.user_data.user_data.right),
                    rear: this.showContent(response.data.user_data.user_data.rear)
                  };

                  this.startProcessError();
                  break;
                case error.WSP_070_COMMUNICATION_ERROR:
                  // 通信エラー
                  this.phase = PHASE.ERROR_COMMUNICATION;
                  break;
                default:
                  // 該当のエラーコードが存在しない場合、共通エラー
                  // ありえないが定義しておく
                  this.showUnexpectedError();
                  break;
              }
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
        this.isDisableButton = true;
      }
    },

    /** 目視確認実行 */
    async execute() {

      // 実行中画面遷移
      this.phase = PHASE.IN_PROGRESS;

      // executeAPI実行
      this.isExecute = true;

      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: 'execute',
          camera_type: this.selectedcameraType
        };

        // 初期処理（要求）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              await this.stop();
              break;
            case config.STATUS_WSP_FAILED:
              // 失敗
              // 各エラー表示
              switch (response.data.async_code) {
                case error.WSP_070_START_PROCESS_ERROR:
                  // 開始処理エラー
                  this.currentProcess = CURRENT_PROCESS.ERROR_START_PROCESS_EXECUTE;

                  // 取得データを割り当て
                  this.resultData = {
                    front: this.showContent(response.data.user_data.user_data.front),
                    left: this.showContent(response.data.user_data.user_data.left),
                    right: this.showContent(response.data.user_data.user_data.right),
                    rear: this.showContent(response.data.user_data.user_data.rear)
                  };

                  this.startProcessError();
                  break;
                case error.WSP_070_COMMUNICATION_ERROR:
                  // 通信エラー
                  this.phase = PHASE.ERROR_COMMUNICATION;
                  break;
                case error.WSP_070_VISUAL_CONFIRMATION_FAILURE:
                  // 目視確認失敗
                  this.showCameraType();
                  this.phase = PHASE.FAILURE_VISUAL_CONFIRMATION;
                  break;
                default:
                  // 該当のエラーコードが存在しない場合、共通エラー
                  // ありえないが定義しておく
                  this.showUnexpectedError();
                  break;
              }
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
        this.isDisableButton = true;
      }
    },

    /** 停止処理 */
    async stop() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: 'stop',
          camera_type: this.selectedcameraType
        };

        // 初期処理（要求）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 成功
              if (this.isExecute) {
                // 目視確認停止処理
                this.inputTarget();
              } else {
                // フロー停止
                await this.terminate();
              }
              break;
            case config.STATUS_WSP_FAILED:
              // 失敗
              // 各エラー表示
              switch (response.data.async_code) {
                case error.WSP_070_STOP_PROCESS_ERROR:
                  // 停止処理エラー
                  this.phase = PHASE.ERROR_STOP_PROCESS;
                  break;
                default:
                  // 該当のエラーコードが存在しない場合、共通エラー
                  // ありえないが定義しておく
                  this.showUnexpectedError();
                  break;
              }
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
        this.isDisableButton = true;
      }
    },

    /** 終了処理 */
    async terminate() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: 'terminate'
        };

        await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

      } finally {
        this.isLoading = false;

        // 画面を閉じる
        this.closeWizard();

        // 初期設定に戻す
        this.phase = PHASE.START;
        this.isExecute = false;
        this.currentProcess = CURRENT_PROCESS.INPUT_TARGET;
      }
    },

    // 表示内容の設定-------------------------------------------

    /**
     * 開始処理エラーの表示内容設定
     */
    startProcessError() {

      // 開始処理エラー画面遷移
      this.phase = PHASE.ERROR_START_PROCESS;


      this.$nextTick(() => {
        // リスト表示項目の設定
        this.startProcessErrorBodyItems = [
          {
            itemID: CAMERA_TYPE.FRONT,
            itemName: this.columns.front,
            itemValue: this.resultData.front
          },
          {
            itemID: CAMERA_TYPE.LEFT,
            itemName: this.columns.left,
            itemValue: this.resultData.left
          },
          {
            itemID: CAMERA_TYPE.RIGHT,
            itemName: this.columns.right,
            itemValue: this.resultData.right
          },
          {
            itemID: CAMERA_TYPE.REAR,
            itemName: this.columns.rear,
            itemValue: this.resultData.rear
          }
        ];
      });

      return;
    },

    /**
     * 目視確認対象選択画面の表示内容設定
     */
    inputTarget() {

      // 目視確認対象選択画面遷移
      this.phase = PHASE.INPUT_TARGET;

      this.$nextTick(() => {
        this.bodyItems = [
          {
            itemID: CAMERA_TYPE.FRONT,
            itemName: this.columns.front
          },
          {
            itemID: CAMERA_TYPE.LEFT,
            itemName: this.columns.left
          },
          {
            itemID: CAMERA_TYPE.RIGHT,
            itemName: this.columns.right
          },
          {
            itemID: CAMERA_TYPE.REAR,
            itemName: this.columns.rear
          }
        ];
      });

      return;
    },

    /**
     * データ読出し結果に対応する表示内容の設定
     * @returns 読み出したデータに対応するエラー内容
     */
    showContent(data_record) {
      switch (data_record) {
        case DATA_RECORD.DATA_PARAM_00:
          // 0x00 (0)
          return this.$t(`individual.data_read_ws70_0x00`);
        case DATA_RECORD.DATA_PARAM_01:
          // 0x01 (1)
          return this.$t(`individual.data_read_ws70_0x01`);
        case DATA_RECORD.DATA_PARAM_11:
          // 0x11 (17)
          return this.$t(`individual.data_read_ws70_0x11`);
        case DATA_RECORD.DATA_PARAM_13:
          // 0x13 (19)
          return this.$t(`individual.data_read_ws70_0x13`);
        case DATA_RECORD.DATA_PARAM_51:
          // 0x51 (81)
          return this.$t(`individual.data_read_ws70_0x51`);
        case DATA_RECORD.DATA_PARAM_61:
          // 0x61 (97)
          return this.$t(`individual.data_read_ws70_0x61`);
        case DATA_RECORD.DATA_PARAM_62:
          // 0x62 (98)
          return this.$t(`individual.data_read_ws70_0x62`);
        case DATA_RECORD.DATA_PARAM_64:
          // 0x64 (100)
          return this.$t(`individual.data_read_ws70_0x64`);
        case DATA_RECORD.DATA_PARAM_65:
          // 0x65 (101)
          return this.$t(`individual.data_read_ws70_0x65`);
        default:
          // 上記以外
          return this.$t(`individual.data_read_ws70_other`);
      }
    },

    /**
     * 目視確認失敗時の表示文言を選んだカメラタイプ次第で設定
     */
    showCameraType() {
      const cameraTypeMap = {
        [CAMERA_TYPE.FRONT]: "front",
        [CAMERA_TYPE.LEFT]: "left",
        [CAMERA_TYPE.RIGHT]: "right",
        [CAMERA_TYPE.REAR]: "rear"
      };

      const suffix = cameraTypeMap[this.selectedcameraType];
      if (suffix) {
        this.replaceMessage = `${this.$t(`individual.value_failed_operation_${suffix}`)} ${this.$t(`${this.i18nWsKey}.REQ_WS_70_TXT_3`)}`;
      }
      return;
    },

    // ユーザ操作-------------------------------------------

    /** 目視確認対象選択画面 選択押下処理 */
    onInputTargetSelectClicked() {
      this.isDisableButton = true;

      // 実行処理に遷移
      this.execute();
    },

    /** 目視確認対象選択画面 キャンセル押下処理 */
    async onInputTargetBackClicked() {
      this.isDisableButton = true;

      // ExecuteAPI未実行
      this.isExecute = false;

      // 未選択状態にしておく
      this.selectedcameraType = null;

      // 停止処理実行
      await this.stop();
    },

    /** 停止処理エラー表示 OK押下処理 */
    async onStopProcessErrorOkClicked() {
      // エラーになった処理によって、OK押下後の処理を変える
      if (this.isExecute) {
        // 目視確認停止処理にてエラー
        this.currentProcess = CURRENT_PROCESS.INPUT_TARGET;
        this.inputTarget();
      } else {
        // フロー停止にてエラー
        this.terminate();
      }
    },

    /** 開始処理エラー OK押下処理 */
    async onStartProcessErrorOkClicked() {
      if (this.currentProcess === CURRENT_PROCESS.ERROR_START_PROCESS_START) {
        // フロー開始でエラー
        this.terminate();
      } else if (this.currentProcess === CURRENT_PROCESS.ERROR_START_PROCESS_EXECUTE) {
        // 目視確認処理開始でエラー
        this.currentProcess = CURRENT_PROCESS.INPUT_TARGET;
        this.inputTarget();
      }
    },

    /** 目視確認失敗 OK押下処理 */
    onVisualConfirmationFailureOkClicked() {
      this.stop();
    },

    /** 通信エラー OK押下処理 */
    onCommunicationErrorOkClicked() {
      this.terminate();
    },

    /** 共通エラー OK押下処理 */
    onCommonErrorOkClicked() {
      this.terminate();
    }
  },

  async mounted() {
    this.init();
    this.start();
  }
};
